<template>
  <div>
    <div>
      <el-form :model="d_form" :rules="rules" ref="d_form" label-width="100px" class="demo-d_add_form">

    <el-form-item label="店铺名称" prop="shop_name" >
      <el-input v-model="d_form.shop_name" placeholder="请输入店铺名称" :disabled="b_disabled"></el-input>
    </el-form-item>

    <el-form-item label="店主" prop="shop_owner" >
        <el-select v-model="d_form.shop_owner" :disabled="b_disabled" clearable placeholder="请选择店主" style="width:100%">
          <el-option
            v-for="item in d_all_user_name"
            :key="item.id"
            :value="item.id"
            :label="item.username"
          > 
          </el-option>
        </el-select>
    </el-form-item>

    <el-form-item label="店铺成员" prop="user_list" >
        <el-select v-model="d_form.user_list" clearable multiple :disabled="b_disabled" placeholder="请选择店铺成员" style="width:100%">
          <el-option
            v-for="item in d_all_user_name"
            :key="item.id"
            :value="item.id"
            :label="item.username"
          > 
          </el-option>
        </el-select>
    </el-form-item>

    <el-form-item label="地域选择" prop="shop_area" >
      <el-cascader :options="china_area_data" clearable v-model="d_form.shop_area"></el-cascader>
    </el-form-item>

    <el-form-item label="区域选择" prop="shop_area" >
      <!-- <el-cascader :options="china_area_data" clearable v-model="d_form.shop_area"></el-cascader> -->
      <el-input v-model="d_form.coordinate" placeholder="请选择区域" :disabled="b_disabled"
      @focus="select_coordinate"
      ></el-input>
    </el-form-item>

    <el-form-item label="店铺地址" prop="shop_address" >
      <el-input v-model="d_form.shop_address" placeholder="请输入店铺地址" :disabled="b_disabled"></el-input>
    </el-form-item>
    
    <el-form-item label="是否启用" prop="is_use">
      <el-switch v-model="d_form.is_use" :disabled="b_disabled"></el-switch>
    </el-form-item>

    <el-form-item label="上传主图(1张)"> 
      <el-upload
        :disabled="b_disabled"
        action= ''
        list-type="picture-card"
        ref='upload'
        :before-remove="remove_main_img"
        :limit=1
        :http-request="upload_main_img"
        :file-list="shop_main_list"
        
      >
      <i class="el-icon-plus"></i>
      </el-upload>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>

    </el-form-item>

    <el-form-item label="轮播图(1-5张)"> 
      <el-upload
        :disabled="b_disabled"
        action= ''
        list-type="picture-card"
        ref='upload'
        :before-remove="handleRemove"
        :limit=5
        :http-request="myUpload"
        :file-list="file_list"
        
      >
      <i class="el-icon-plus"></i>
      </el-upload>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>

    </el-form-item>

    
    <el-form-item class="sssss">
      <el-button type="primary" @click="submitForm('d_form')" :disabled="b_disabled">{{ s_btn_name }}</el-button>
      <el-button @click="cancel_func">取消</el-button>
    </el-form-item>
  </el-form>
    </div>

    <div>
      <el-dialog  :visible.sync="b_coordinate_dialog" :fullscreen="b_show_coordinate_fullscreen" :show-close="false" width="1200px">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">选择部门</span>
        <el-button icon="el-icon-close" class='dialog-title-button' @click="b_coordinate_dialog = false"></el-button>
        <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_coordinate_fullscreen = !b_show_coordinate_fullscreen"></el-button>
      </div>

      <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="" class="from-label" >
			    <el-input size="small" v-model="search_coordinate_info" placeholder="请输入店铺名称" clearable></el-input>
			  </el-form-item>

         <el-form-item>
			    <el-button type="primary" @click="find_coordinate_info" size="small" icon="el-icon-search">查询</el-button>
					
			  </el-form-item>
      </el-form>

      
      <div style="width:500px;height:500px;">
    <div id="info">当前点击坐标为：<span id="position"></span>
    </div>
    <div id="container" style="width:1000px;height:700px;">
    </div>
    </div>
   </el-dialog>

    </div>

  </div>

</template>
<script>
 
  // import { regionData, TextToCode } from 'element-china-area-data'
  import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'

  export default {
    
    name: 'add_shop',
    // props: ['DialogType'], 
    props: ['DialogType', 'dSelectShopData'],
    
    data() {
      
      return {
        search_coordinate_info: '',

        china_area_data: regionData,

        dialogImageUrl: '',
        dialogVisible: false,

        // 表单按钮名称
        s_btn_name: '',

        // 禁用按钮
        b_disabled: false,

        // 已有的店主
        d_all_user_name: [],

        dialog_type: this.DialogType,

        d_select_shop: this.dSelectShopData,

        // 记录文件列表
        file_list: [],

        // 主图记录表
        shop_main_list: [],

        d_form: {},

        d_add_form: {
          updater_user: parseInt(window.sessionStorage.getItem('id')),
          shop_name: '',

          user_list: [],

          shop_owner: '',

          shop_address: '',

          is_use: false,

          img_list: [],
          
          shop_main_img: '',

          shop_area: [],

        },
        rules: {
          shop_name: [
            { required: true, message: '请输入店铺名称', trigger: 'blur' },
            { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
          ],

          is_use: [
            { required: true, message: '确定此店铺是否开启', trigger: 'change' }
          ],

          id: [
            { required: true, message: '请选择用户名', trigger: 'blur' }
          ],
          
          shop_address: [
            { required: true, message: '请输入店铺地址', trigger: 'blur' }
          ],
         
        },

        b_coordinate_dialog: false,
        b_show_coordinate_fullscreen: false,

      };
    },
    mounted() {
      var _this = this

      if (this.dialog_type === 1){
        this.d_form = JSON.parse(JSON.stringify(this.d_add_form))
        this.s_btn_name = '立即创建'

      } else if (this.dialog_type === 2){
        this.d_form = JSON.parse(JSON.stringify(this.d_select_shop))
        this.changeShopOwnerData()
        console.log(this.d_form)
        var l_img_list = this.d_form.img_list
        this.s_btn_name = '保存'
        this.shop_main_list = [{url: this.d_form.shop_main_img}]
        for (var i_index=0; i_index<l_img_list.length; i_index++){
          var url = l_img_list[i_index]
          // 显示图片的列表
          this.file_list.push({url: url})
        }
      } else if (this.dialog_type === 3){
        this.d_form = JSON.parse(JSON.stringify(this.d_select_shop))
        this.changeShopOwnerData()
        this.b_disabled = true
        this.s_btn_name = '禁止操作'
        this.shop_main_list = [{url: this.d_form.shop_main_img}]
        var l_img_list = this.d_form.img_list
        for (var i_index=0; i_index<l_img_list.length; i_index++){
          var url = l_img_list[i_index]
          // 显示图片的列表
          this.file_list.push({url: url})
        }
      }

      var d_user_data = {"is_business": 1}

      _this.$axios.get('/api/users/', {params: d_user_data}).then(
        function(res){
        _this.d_all_user_name = res.data
        }
      )
    },
    methods: {

      // 选择坐标
      select_coordinate(){
        console.log('111')
        this.b_coordinate_dialog = true
        this.initMap()
      },

      // 关闭抽屉
      close_drawer(){
        this.b_coordinate_dialog = false
      },

      find_coordinate_info(){

      },

      initMap() {
      var center = new TMap.LatLng(39.984104, 116.307503);
      console.log(888888888888)
      //定义工厂模式函数
      var map = new TMap.Map("container", {
                rotation: 20,//设置地图旋转角度
                pitch:30, //设置俯仰角度（0~45）
                zoom:12,//设置地图缩放级别
                center: center//设置地图中心点坐标
            });
      // //获取dom元素添加地图信息
      // var map = new qq.maps.Map(document.getElementById("container"), myOptions);
      console.log(1111111111111)
      var position = document.getElementById("position");
      console.log(22222222222222222222)

      var markerLayer = null;

      var markerLayer = new TMap.MultiMarker({
            id: 'marker-layer',
            map: map,
            // position: {lat: 40.022783232606145, lng: 116.21682817917826, height: 0},
        });

      // 初始化地图 如果有坐标 则加入marker
      markerLayer.add({
            position: new TMap.LatLng(40.00526193662964, 116.30947547660253),
          });

      // var search = new TMap.service.Search({ pageSize: 10 })

      map.on("click",function(evt){

          // 清空markerLayer
          // markerLayer.clearMarkers();
          // 删除上一个mark
          if (markerLayer){
            console.log(markerLayer)
            markerLayer.setMap(null)
            markerLayer = null
            markerLayer = new TMap.MultiMarker({
            id: 'marker-layer',
            map: map
        });
          }

          

          markerLayer.geometries = [];
          var lat = evt.latLng.getLat().toFixed(6);
          var lng = evt.latLng.getLng().toFixed(6);
          position.innerHTML = lat + "," + lng;

          console.log(evt.latLng)
          markerLayer.add({
            position: evt.latLng
          });
      })

    },


      // 修改shop_owner为id
      changeShopOwnerData() {
        console.log(121212112)
        console.log(Object.keys(this.d_form.shop_owner)[0])
        this.d_form.shop_owner = parseInt(Object.keys(this.d_form.shop_owner)[0])
        this.d_form.updater_user = Object.keys(this.d_form.updater_user)[0]
      },
      
      // 新建店铺
      submitForm(formName) {
        var _this = this
        console.log(this.d_form)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 上传表单
            if (this.dialog_type === 1) {
              var url= '/api/shops/'
              this.$axios.post(url, this.d_form).then(function(res){
                console.log(res.data)
                
              })

            }else if (this.dialog_type === 2){
              var url= '/api/shops/' + this.d_form.shop_id + '/'
              this.$axios.put(url, this.d_form).then(function(res){
                console.log(res.data)
              })
            }

            // 通知父组件完成, 关闭窗口
            this.$emit("AddShopOkFunc", false)

          } else {
            // 失败提示
            _this.$message({
              showClose: true,
              message: '新建店铺失败',
              type: 'error',
              center: true,
              offset: 50
            });
            return false;
          }});
      },

      // 取消
      cancel_func() {
        this.$emit("AddShopOkFunc", false, this.dialog_type)
      },

      // 删除图片事件
      handleRemove(file, fileList) {
        console.log(fileList)
        var s_remove_url = file.url
        var _this = this

        let d_data = {'s_url': s_remove_url}
        let url = "/api/remove_file/"
        this.$axios.post(url, d_data).then(function(res){
          console.log(res.data)

          // 删除表单中的url
          var i_index = _this.d_form.img_list.indexOf(s_remove_url)
          _this.d_form.img_list.splice(i_index, 1)
          
          for (var i_index=0; i_index<_this.file_list.length; i_index++){
            if (_this.file_list[i_index].url === s_remove_url){
              _this.file_list.splice(i_index, 1)
              break
            }
          }
        
        }).catch(function(error){
           _this.$message({
            showClose: true,
            message: '删除文件失败,请重试',
            type: 'error',
            center: true,
            offset: 50
          });
        })
      },

      // 上传包间主图
      async upload_main_img(option){
         const res = await this.upload_common(option)
         this.d_form.shop_main_img = res.data.s_url
      },

      // 删除包间主图
      async remove_main_img(){
        let s_remove_url = this.d_form.shop_main_img
        await this.remove_common(s_remove_url)
        this.d_form.shop_main_img = ''
      },
      
      // 上传图片事件
      myUpload(option){
        console.log(option)
        var _this = this
        const file_content = option.file
        const fileType = file_content.type
        const isImage = fileType.indexOf("image") != -1
        
        // 是否图片
        if (!isImage) {
          this.$message.error("只能上传图片格式png、jpg");
          return;
        }

        // 根据后台需求数据格式
        const form = new FormData();

        // 文件对象
        form.append("file", file_content);
        form.append('folder', "shop_img")
        var url= '/api/upload_file/'
        this.$axios.post(
          url, form, {headers: {"content-type": "multipart/form-data"}}
        ).then(function(res){
          if (res.data.code === 1011){
            console.log(res.data)
          }else{
            
            _this.d_form.img_list.push(res.data.s_url)
            // _this.file_list.push({'url': res.data.s_url})
            option.onSuccess(res)
          }

        }).catch(function(error){
          console.log(error);
          _this.$message({
            showClose: true,
            message: '请求服务器失败,请重试',
            type: 'error',
            center: true,
            offset: 50
          });
        })
      },

      // 上传文件成功后的回调
      handleUploadSuccess(response, file, fileList){
        file.url = response.data.s_url
        this.file_list.push(file)
        console.log(this.file_list)
      },

      // 上传文件通用接口
      upload_common(option){
        
        let p_file = option.file
        let l_file_type = p_file.type
        let b_is_image = l_file_type.indexOf("image") != -1

        // 是否图片
        if (!b_is_image) {
          this.$message.error("只能上传图片格式png、jpg");
          return
        }

        // form 表单
        let d_form_data = new FormData()

        d_form_data.append("file", p_file)
        d_form_data.append('folder', "shop_img")
        let url= '/api/upload_file/'

        let res = this.$axios.post(
            url, d_form_data, {headers: {"content-type": "multipart/form-data"}}
        )
        console.log(res)
        console.log(res.data)
        return res
      },

      // 删除文件通用接口
      remove_common(s_remove_url){
        let url = "/api/remove_file/"
        let d_data = {'s_url': s_remove_url}
        let res = this.$axios.post(url, d_data)
        console.log(res)
        return res
      },
      
    }
  }


</script>

<style>
.tes {
  background: rgb(235, 22, 22);
}
</style>